import {createSelector} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {IFileEntryState} from '@app/core/store/state/file-entry.state';

const _selectFileEntry = (state: IAppState) => state.fileEntry;

export const selectUploadedFiles = createSelector(
	_selectFileEntry,
	(state: IFileEntryState) => state.uploadedFiles,
);
export const selectFileEntries = createSelector(
	_selectFileEntry,
	(state: IFileEntryState) => state.fileEntries,
);

export const selectFileEntryPagination = createSelector(
	_selectFileEntry,
	(state: IFileEntryState) => state.pagination,
);

export const selectFileEntryIsLoading = createSelector(
	_selectFileEntry,
	(state: IFileEntryState) => state.isLoading,
);
